import React from "react";
import {useHistory} from "react-router-dom";
import {useIntegrationsData} from "./hooks";
import {useTranslation} from "react-i18next";
import {PATHS} from "../../route-dictionary";
import AddButtonRow from "../../components/AddButtonRow";
import {withErrorBoundary} from "../../components/ErrorBoundary";
import {getFullNameFromType, getTableNoItemsView} from "../../utils";
import {ACTIONS, hasGlobalPermission} from "../../utils/user-access";
import {CCard, CCardBody, CCardHeader, CDataTable} from "@coreui/react";
import {getTableColumnHeaders, integrationsTypes} from "./Integrations.model";
import "./Integrations.scss";

const Integrations = () => {
  const history = useHistory();
  const {t} = useTranslation();
  const {loading, integrationsData} = useIntegrationsData();

  const getClickAction = (id) => hasGlobalPermission(ACTIONS.EDIT_INTEGRATIONS) &&
    history.push(PATHS.INTEGRATIONS.getDetailsIdPath(id));

  return (
    <CCard className="Integrations-card">
      <CCardHeader>
        <h1 className="card-header-text">
          {t("card.title.integrations", "Integrations")}
        </h1>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          addTableClasses="Integrations-card__integrations-table integrations-table"
          items={integrationsData}
          fields={getTableColumnHeaders()}
          noItemsView={getTableNoItemsView()}
          overTableSlot={
            <AddButtonRow
              path={PATHS.INTEGRATIONS.ADD}
              hasAddPermission={hasGlobalPermission(ACTIONS.CREATE_INTEGRATIONS)}
            />
          }
          hover
          striped
          border
          loading={loading}
          clickableRows={hasGlobalPermission(ACTIONS.EDIT_INTEGRATIONS) || undefined}
          onRowClick={(item) => getClickAction(item.id)}
          scopedSlots={
            {
              "name": hasGlobalPermission(ACTIONS.VIEW_INTEGRATIONS) ?
                (item) => (
                  <td className="integrations-table__cell">
                    {item.name || ""}
                  </td>
                ) : null,
              "type": hasGlobalPermission(ACTIONS.VIEW_INTEGRATIONS) ?
                (item) => (
                  <td className="integrations-table__cell">
                    {getFullNameFromType(item.type, integrationsTypes) || ""}
                  </td>
                ) : null,
            }
          }
        />
      </CCardBody>
    </CCard>
  );
};

export default withErrorBoundary(Integrations);